import script from "./SimpleQuizPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleQuizPage.vue?vue&type=script&setup=true&lang=js"

import "./SimpleQuizPage.vue?vue&type=style&index=0&id=2a5d30a2&lang=scss&scoped=true"

import exportComponent from "D:\\Dev\\ClimEco\\Django\\ClimEco\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5d30a2"]])

export default __exports__